export default {
  containerStyles: {
    backgroundColor: "#FFF",
    cursor: "auto",
    padding: 10,
    borderRadius: 10,
    borderColor: "#efefef",
    borderWidth: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    shadowOffset: {
      width: 5,
      height: 5
    },
    shadowColor: "#efefff",
    shadowOpacity: 0.5,
    shadowRadius: 10,
    elevation: 1
  }
};